/**
 * Shared constants for Class Dashboard pages.
 * Update here → every page stays in sync automatically.
 */

import { TIER_COLOR, READINESS_BAND_COLORS, BAND_COLOR } from '../../utils/constants';
export { TIER_COLOR, READINESS_BAND_COLORS, BAND_COLOR };

export const RISK_LEVEL_COLOR = {
    Low:    '#A5A5A5',
    Medium: '#7B8FC7',
    High:   '#FF6900',
};

export const MASTERY_BAND_COLOR = {
    Fragile:    '#E04535',
    Developing: '#EFA020',
    Secure:     '#1B6B55',
};
